import { useEffectOnce } from 'react-use';
import { IndicationContent, INDICATION_TYPES } from 'taboola-ultimate-ui';
import { POST_MESSAGES_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './successToast.module.scss';

export const SuccessToast = ({ navigateToStepId }) => {
    useEffectOnce(() =>
        window.parent.postMessage({
            type: POST_MESSAGES_TYPES.SHOW_SUCCESS_MODAL,
        })
    );

    const closeToast = () => {
        window.parent.postMessage({
            type: POST_MESSAGES_TYPES.CLOSE,
        });
    };

    return (
        <div className={styles['success-notification-bar']} role="alert">
            <div className={styles['success-icon-container']}>
                <IndicationContent
                    type={INDICATION_TYPES.SUCCESS}
                    contentClassName={styles['success-indication-message']}
                    displayIcon
                />
            </div>
            <span className={styles['success-message']}>
                <FormattedMessage
                    id="codeless.review.event.success.message"
                    defaultMessage="<b>The event has been created successfully</b> - You may now close this window."
                />
            </span>
            <button className={styles['success-close-button']} aria-label="Close notification" onClick={closeToast}>
                ×
            </button>
        </div>
    );
};
